import { LeaveRequestRecord } from '../types';

export interface AllocationTotals {
	approvedDays: number;
	pendingDays: number;
	deniedDays: number;
}

// Tracks active change requests so approved originals don't double-count in allocations.
export const getActiveChangeOriginalIds = (requests: LeaveRequestRecord[]): Set<string> => {
	const ids = new Set<string>();
	requests.forEach((request) => {
		if (request.status === 'CHANGE_PENDING' && request.change?.originalRequestId) {
			ids.add(request.change.originalRequestId);
		}
	});
	return ids;
};

export const calculateAllocationTotals = (
	requests: LeaveRequestRecord[],
	year: number
): AllocationTotals => {
	const activeChangeOriginalIds = getActiveChangeOriginalIds(requests);
	const totals: AllocationTotals = { approvedDays: 0, pendingDays: 0, deniedDays: 0 };

	requests.forEach((request) => {
		if (request.period.year !== year) return;

		if (request.status === 'APPROVED') {
			if (activeChangeOriginalIds.has(request.id)) {
				// Original request is superseded by a change request and should not count.
				return;
			}
			totals.approvedDays += request.period.totalDays || 0;
			return;
		}

		if (request.status === 'PENDING' || request.status === 'CHANGE_PENDING') {
			// Treat change requests the same as pending for allocation usage.
			totals.pendingDays += request.period.totalDays || 0;
			return;
		}

		if (request.status === 'DENIED') {
			totals.deniedDays += request.period.totalDays || 0;
		}
	});

	return totals;
};
